const translations = {
    title: 'Rejestracja firmy',
    description: '',
    canonical: 'string',
    image: '',
    robots: '',
};

export default translations;